import React from 'react';

import classname from '@search/classname/src';

import './ClOrderOfferVasOption.css';
import { Typography } from '@vtblife/uikit';
const cn = classname.bind(null, 'ClOrderOfferVasOption');

type IProps = {
    isMobile?: boolean;
    isActive: boolean;
    onClick: () => void;
    title: string;
    date: string;
    actualPrice: number;
    oldPrice?: number;
    discount?: number;
}

export const ClOrderOfferVasOption: React.FC<IProps> = ({
    isMobile,
    isActive,
    onClick,
    title,
    date,
    actualPrice,
    oldPrice,
    discount
}) => {
    return (
        <div className={cn(null, { isActive })} onClick={onClick}>
            <div className={cn('top-block', { isMobile })}>
                <Typography variant='h4' bold>
                    {title}
                </Typography>
                {Boolean(discount) && (
                    <Typography variant='small-alone' color='white-500' className={cn('discount')}>
                        –&nbsp;{discount}%
                    </Typography>
                )}
            </div>
            <div className={cn('bottom-block', { isMobile })}>
                <Typography
                    variant='secondary-alone'
                    color={isMobile ? 'secondary' : 'black-250'}
                    className={cn('expired', { isMobile })}
                >
                    до&nbsp;{date}
                </Typography>
                <div className={cn('price')}>
                    {Boolean(oldPrice) && (
                        <Typography
                            variant='primary-alone'
                            color={isMobile ? 'secondary' : 'black-250'}
                            className={cn('price-old', { isMobile })}
                        >
                            {oldPrice}&nbsp;₽
                        </Typography>
                    )}
                    {actualPrice && (
                        <Typography variant='primary-alone'>
                            {actualPrice}&nbsp;₽
                        </Typography>
                    )}
                </div>
            </div>
        </div>
    );
};
